import React from "react"
import { useAppSelector } from "../../../shared/hooks"
import AddFormToCaseListItem from "./AddFormToCaseListItem"

interface Props {
  caseId: string
  handleClose: () => void
  setPreviewingTemplateId: (id: string) => void
}

const AddFormToCaseList: React.FC<Props> = (props: Props) => {
  const formTemplateIds: string[] = useAppSelector((state)=> state.entities.formTemplates.allIds)
  return <ul>
    {formTemplateIds.map((id) =>
      <AddFormToCaseListItem formTemplateId={id} key={id} handleClose={props.handleClose} caseId={props.caseId} setPreviewingTemplateId={props.setPreviewingTemplateId} />
    )}
    </ul>
}

export default AddFormToCaseList
